<template>
  <div class="col-12 connections py-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Реквизиты</h5>
      </div>
      <div class="card-body">
        <div v-for="(org, index) in organizations" :key="index" class="connections-list">
          <div class="connections-list__header">
            <h5 class="blue">{{ org.title }}</h5>
          </div>
          <ul class="info-list d-flex justify-content-between mt-3 flex-md-row flex-column">
            <li v-for="(item, index) in org.lists" :key="index" style="min-width: 20%">
              <span class="info-title">{{ item.label }}</span>
              <span class="info-value">{{ item.value }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { defineComponent, ref } from 'vue';
  import moment from 'moment';

  export default defineComponent({
    name: 'Details',
    props: {
      company: Object,
    },
    setup(props) {
      const selectedType = ref('Все');
      const isEntrepreneur = !!(props.company?.fio && !props.company?.name);
      const isChineseCompany = !!(props.company?.company_name_en && props.company?.uscc && !props.company?.inn);

      const formatDate = (date) => {
        return moment(date).format('DD.MM.YYYY');
      };

      const organizations = ref(
        isChineseCompany
          ? [
              {
                title: 'Основная информация',
                lists: [
                  { label: 'Название (EN)', value: props.company.company_name_en },
                  { label: 'USCC', value: props.company.uscc },
                  { label: 'Регион / город', value: props.company.country_province_city },
                  { label: 'Отрасль', value: props.company.industry },
                  { label: 'Официальный сайт', value: props.company.official_website },
                ],
              },
            ]
          : isEntrepreneur
          ? [
              {
                title: 'Основная информация',
                lists: [
                  { label: 'ИНН', value: props.company.inn },
                  { label: 'ОГРНИП', value: props.company.ogrn },
                  { label: 'ОКПО', value: props.company.okpo },
                  {
                    label: 'Дата регистрации',
                    value: formatDate(props.company.registration_date),
                  },
                  {
                    label: 'Налоговый орган',
                    value: props.company.taxAuthority?.name,
                  },
                ],
              },
              {
                title: 'Сведения Росстата',
                lists: [
                  { label: 'ОКАТО', value: props.company.okato?.code },
                  { label: 'ОКФС', value: props.company.okfs?.code },
                  {
                    label: 'ОКТМО',
                    value: props.company.oktmo?.code + ', ' + props.company.oktmo?.name,
                  },
                  {
                    label: 'ОКОГУ',
                    value: props.company.okogu?.code + ', ' + props.company.okogu?.name,
                  },
                  {
                    label: 'ОКОПФ',
                    value: props.company.okopf?.code,
                  },
                ],
              },
              {
                title: 'Регистрация во внебюджетных фондах',
                lists: [
                  {
                    label: 'ПФР',
                    value: props.company.pensionFund?.registration_number,
                  },
                  {
                    label: 'Дата регистрации в ПФР',
                    value: formatDate(props.company.pensionFund?.registration_date),
                  },
                  {
                    label: 'ФСС',
                    value: props.company.socialInsuranceFund?.registration_number,
                  },
                  {
                    label: 'Дата регистрации в ФСС',
                    value: formatDate(props.company.socialInsuranceFund?.registration_date),
                  },
                  {
                    label: 'Город',
                    value: props.company.city,
                  },
                ],
              },
            ]
          : [
              {
                title: 'Основная информация',
                lists: [
                  { label: 'ИНН', value: props.company.inn },
                  { label: 'КПП', value: props.company.kpp },
                  { label: 'ОГРН', value: props.company.ogrn },
                  {
                    label: 'Дата постановки на учет',
                    value: formatDate(props.company.registration_date),
                  },
                  {
                    label: 'Налоговый орган',
                    value: props.company.taxAuthority?.name,
                  },
                ],
              },
              {
                title: 'Сведения Росстата',
                lists: [
                  { label: 'ОКПО', value: props.company.okpo },
                  { label: 'ОКАТО', value: props.company.okato?.code },
                  { label: 'ОКФС', value: props.company.okfs?.code },
                  {
                    label: 'ОКТМО',
                    value: props.company.oktmo?.code + ', ' + props.company.oktmo?.name,
                  },
                  {
                    label: 'ОКОГУ',
                    value: props.company.okogu?.code + ', ' + props.company.okogu?.name,
                  },
                ],
              },
              {
                title: 'Сведения о регистрации в ФНС',
                lists: [
                  { label: 'ОГРН', value: props.company.ogrn },
                  {
                    label: 'Дата присвоения ОГРН',
                    value: formatDate(props.company.ogrn_start_date),
                  },
                  {
                    label: 'Регистратор',
                    value: props.company.taxAuthority?.name,
                  },
                  {
                    label: 'Адрес регистратора',
                    value: props.company.taxAuthority?.address,
                  },
                ],
              },
              {
                title: 'Сведения о регистрации в ПФР ',
                lists: [
                  {
                    label: 'Регистрационный номер',
                    value: props.company.pensionFund?.registration_number,
                  },
                  {
                    label: 'Дата регистрации',
                    value: formatDate(props.company.pensionFund?.registration_date),
                  },
                  {
                    label: 'Наименование территориального отдыха',
                    value: props.company.pensionFund?.name,
                  },
                ],
              },
              {
                title: 'Сведения о регистрации в ФСС ',
                lists: [
                  {
                    label: 'Регистрационный номер',
                    value: props.company.socialInsuranceFund?.registration_number,
                  },
                  {
                    label: 'Дата регистрации',
                    value: formatDate(props.company.socialInsuranceFund?.registration_date),
                  },
                  {
                    label: 'Наименование территориального отдыха',
                    value: props.company.socialInsuranceFund?.name,
                  },
                ],
              },
            ]
      );

      return {
        selectedType,
        organizations,
        formatDate,
      };
    },
  });
</script>
